<app-page-header title="Home" active_item="Aprovar saques"></app-page-header>
<div class="loading-approve" *ngIf="!isLoaded">
  <div class="dimmer active">
    <div class="lds-ring">
      <div></div>
    </div>
  </div>
</div>
<h5>Aprovar saques</h5>
<div class="row">
  <div class="col-12">
    <div class="card rounded-10 shadow">
      <div class="card-header">
        <div class="card-title mb-0">Saques</div>
        <div class="card-options">
          <button
            type="button"
            class="our-button btn btn-pill btn-warning float-end"
            (click)="reload()"
          >
            <i class="fe fe-refresh-cw"></i>Atualizar
          </button>
          <button
            type="button"
            class="our-button btn btn-pill btn-danger float-end"
            (click)="approve(false)"
          >
            <i class="fe fe-x"></i>Reprovar
          </button>
          <button
            type="button"
            class="our-button btn btn-pill btn-primary float-end"
            (click)="approve(true)"
          >
            <i class="fe fe-check"></i>Aprovar
          </button>
        </div>
      </div>
      <div class="card-body">
        <div class="scrollable-layout">
          <div class="table-responsive our-table">
            <table class="table table-striped text-nowrap mb-0">
              <thead class="border-top">
                <tr>
                  <th class="align-middle text-center" scope="col">
                    Selecionar
                  </th>
                  <th class="align-middle text-center" scope="col">Data</th>
                  <th scope="col">Identificador</th>
                  <th scope="col">End2EndId</th>
                  <th scope="col">Nome</th>
                  <th scope="col">Pix</th>
                  <th scope="col">Tipo</th>
                  <th scope="col">Status</th>
                  <th scope="col">Valor</th>
                </tr>
              </thead>
              <tbody>
                <tr class="border-bottom" *ngFor="let data of tableData">
                  <td class="align-middle text-center">
                    <label class="custom-switch">
                      <input
                        type="checkbox"
                        class="custom-switch-input"
                        [(ngModel)]="data.selected"
                      />
                      <span class="custom-switch-indicator"></span>
                    </label>
                  </td>
                  <td class="align-middle text-center">
                    <span>{{
                      data.date | date : "dd/MM/yyyy HH:mm:ss" : "GMT"
                    }}</span>
                  </td>
                  <td>
                    <span>{{ data.id }}</span>
                  </td>
                  <td>
                    <span>{{ data.endToEndId }}</span>
                  </td>
                  <td>
                    <span>{{ data.name }}</span>
                  </td>
                  <td>
                    <span>{{ data.pixKey }}</span>
                  </td>
                  <td>
                    <span>{{ data.pixType }}</span>
                  </td>
                  <td>
                    <span>{{ data.status }}</span>
                  </td>
                  <td>
                    <span>R$ {{
                      data.valor
                        | mask
                          : "separator.2"
                          : { decimalMarker: ",", leadZero: true }
                    }}</span>
                  </td>
                </tr>
                <tr *ngIf="tableData.length == 0">
                  <td colspan="9">Não contém dados</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #modalConfirmEnable let-modal>
  <div class="modal-content" style="padding: 0 !important;">
    <div class="modal-header">
      <h5 class="modal-title">{{isAprove ? 'Aprovar' : 'Reprovar' }} transações selecionadas?</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click'); getPendingWithdraw();"></button>
    </div>
    <div class="modal-body">
      <p>Este processo irá {{isAprove ? 'aprovar' : 'reprovar' }} as transações selecionadas.</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.close('Close click'); getPendingWithdraw();">Cancelar</button>
      <button class="btn btn-{{!isAprove ? 'primary' : 'danger'}}" type="button" (click)="executeAprove()">{{!isAprove ? 'Aprovar' : 'Reprovar' }}</button>
    </div>
  </div>
</ng-template>
